class ParserUtils {
  parseClassName<T extends Record<string, unknown>>(
    className: string | T | null | undefined,
    defaultKey: keyof T
  ): T {
    if (typeof className === "string") {
      return { [defaultKey]: className } as T;
    }

    return (className ?? {}) as T;
  }
}

const parserUtils = new ParserUtils();

export default parserUtils;
